<template>
  <div class="quick-view">
    <v-dialog max-width="700" v-model="dialog">
      <v-card title="Dialog">
        <!-- زر الإغلاق في أعلى اليمين -->
        <v-hover v-slot:default="{ isHovering, props }">
          <div v-bind="props" style="position: relative">
            <v-icon
              @click="dialog = false"
              style="
                font-size: 35px;
                position: absolute;
                top: -35px;
                right: 30px;
                cursor: pointer;
              "
              :color="isHovering ? 'blue' : 'black'"
            >
              mdi-share-outline
            </v-icon>
          </div>
        </v-hover>

        <v-container class="bg-white">
          <v-row>
            <v-col cols="12" sm="6">
              <img
                v-if="!loading"
                class="w-100"
                style="height: 400px"
                :src="
                  picTap
                    ? picTap
                    : dataView.thumbnail
                    ? dataView.thumbnail
                    : route.query.name === 'hossam'
                    ? dataView.image
                    : route.query.name === 'woman'
                    ? dataView.image
                    : dataView.image
                "
                alt=""
              />
              <v-skeleton-loader
                v-if="loading"
                type="image, article"
              ></v-skeleton-loader>

              <v-tabs center-active height="200">
                <v-tab
                  v-model="picTap"
                  v-for="(img, i) in dataView.images"
                  :key="i"
                  :value="img"
                  @click="picTap = img"
                >
                  <img style="height: 100px; width: 100px" :src="img" alt="" />
                </v-tab>
              </v-tabs>
            </v-col>

            <v-col cols="12" sm="6">
              <v-skeleton-loader
                v-if="loading"
                type="article,article"
                class="w-100"
              />

              <v-card v-else elevation="0" class="text-start pl-0">
                <v-card-title
                  class="px-0"
                  style="
                    font-size: 15px;
                    font-weight: bold;
                    white-space: pre-wrap;
                  "
                >
                  {{ dataView.title }} Sample - {{ dataView.category }} For Sale
                </v-card-title>

                <div class="rating d-flex justify-start align-center">
                  <v-rating
                    v-model="ratingValue"
                    half-increments
                    readonly
                    color="yellow-darken-2"
                    size="x-small"
                    density="compact"
                  />
                  <span style="margin-left: 10px"
                    >stock - {{ dataView.stock }}</span
                  >
                </div>

                <v-card-text
                  class="px-0"
                  style="text-align: start; line-height: 1.2; color: #858282"
                >
                  {{ dataView.description }}
                </v-card-text>

                <v-card-text
                  class="text-brand px-0"
                  style="text-align: start; margin-top: -15px"
                >
                  {{
                    dataView.brand
                      ? dataView.brand
                      : route.query.name === "hossam"
                      ? "food"
                      : route.query.name === "woman"
                      ? dataView.category
                      : dataView.category
                  }}
                </v-card-text>

                <v-card-text
                  class="px-0 pt-0"
                  style="font-size: 13px; color: rgb(96, 96, 96)"
                >
                  Availability:
                  <span
                    :style="{ color: dataView.stock > 0 ? 'green' : 'red' }"
                  >
                    {{ dataView.stock > 0 ? "In Stock" : "Out Of Stock" }}
                  </span>
                </v-card-text>

                <v-card-text class="pt-0 px-0">
                  <span v-if="dataView.discountPercentage">
                    <del class="mr-1" style="opacity: 0.5">{{
                      dataView.price
                    }}</del>
                    <span style="font-weight: 700; margin-right: 2px"
                      >From</span
                    >
                  </span>
                  <span
                    style="font-size: 16px; font-weight: 900; color: #ff0000"
                  >
                    {{
                      dataView.discountPercentage
                        ? Math.ceil(
                            dataView.price -
                              dataView.price *
                                (dataView.discountPercentage / 100)
                          )
                        : dataView.price
                    }}$
                  </span>
                </v-card-text>

                <v-card-text class="pl-0 pt-3">
                  Quantity
                  <div
                    class="counter px-1"
                    style="
                      border-radius: 30px;
                      border: 1px solid rgb(201, 201, 201);
                      width: fit-content;
                    "
                  >
                    <v-icon @click="Quantity > 1 ? Quantity-- : false" size="22"
                      >mdi-minus</v-icon
                    >
                    <input
                      type="number"
                      style="outline: none; width: 60px; font-size: 13px"
                      min="1"
                      v-model="Quantity"
                      class="text-center py-2"
                    />
                    <v-icon @click="Quantity++" size="22">mdi-plus</v-icon>
                  </div>
                  <v-card-text>
                    Subtotal:
                    {{
                      dataView.discountPercentage
                        ? Math.ceil(
                            (dataView.price -
                              dataView.price *
                                (dataView.discountPercentage / 100)) *
                              Quantity
                          )
                        : Math.ceil(dataView.price * Quantity)
                    }}
                  </v-card-text>
                </v-card-text>

                <v-card-actions class="mt-3 w-100">
                  <div>
                    <v-btn
                      @click="addToCard(dataView)"
                      :loading="loadingSand"
                      variant="outlined"
                      style="
                        height: 45px;
                        text-transform: none;
                        border-radius: 30px;
                        color: rgb(255 255 255);
                        background-color: #2196f3;
                        text-transform: capitalize;
                        font-weight: 700;
                        width: 270px;
                      "
                      density="compact"
                    >
                      Add to Cart
                    </v-btn>

                    <div
                      v-if="showDone"
                      style="
                        display: flex;
                        align-items: center;
                        color: green;
                        margin-top: 10px;
                      "
                    >
                      <v-icon color="green">mdi-check-circle</v-icon>
                      <span style="margin-left: 5px">
                        (({{ dataView.brand }})) It has been successfully added
                        to your shopping cart
                      </span>
                    </div>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script setup>
const dialog = ref(false);

const ratingValue = computed(() => {
  if (dataView.value && dataView.value.rating) {
    return route.query.name === "hossam"
      ? dataView.value.rating
      : dataView.value.rating.rate;
  }
  return 0;
});

import { ref, onMounted, computed, inject } from "vue";
import { products } from "@/store/GetProducts";
import { ladies } from "@/store/LadiesFashion";
import { phone } from "@/store/PhonesData";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { cards } from "@/store/card";

const cardItem = cards();
const route = useRoute();
const singleD = products();
const wom = ladies();
const datPhone = phone();
const { singlePhone } = storeToRefs(datPhone);
const { single } = storeToRefs(singleD);
const { womData } = storeToRefs(wom);
const getDataCard = cardItem.getDataCard;
const addToCard = (item) => {
  item.quantity = Quantity.value;
  getDataCard(item);
  lodingSand.value = true;
  showDone.value = false; // Reset the done message

  setTimeout(() => {
    lodingSand.value = false;
    showDone.value = true; // Show the done message

    // Hide the done message after 2 seconds
    setTimeout(() => {
      showDone.value = false;
    }, 2000);
  }, 1000);
};

const Emitter = inject("Emitter");
onMounted(() => {
  loding.value = true;

  Emitter.on("openView", (data) => {
    dialog.value = true;
    dataView.value = data;

    setTimeout(() => {
      loding.value = false;
    }, 1000);
  });
});
const lodingSand = ref(false);
const showDone = ref(false);

const dataView = ref("");

const picTap = ref("");
const Quantity = ref(1);
const loding = ref(false);

const getSinglePhone = async () => {
  await datPhone.getSinglePro(route.params.productId);
  dataView.value = singlePhone.value;
};

const getSingleData = async () => {
  loding.value = true;
  await singleD.getSinglePro(route.params.productId);
  dataView.value = single.value;

  loding.value = false;
};
const getSingleDatawom = async () => {
  await wom.getSinglePro(route.params.productId);
  dataView.value = womData.value;
};

onMounted(() => {
  if (route.query.name === "hossam") {
    getSingleData();
  } else if (route.query.name === "woman") {
    getSingleDatawom();
  } else if (route.query.name === "phone") {
    getSinglePhone();
  }
});
</script>
